var _script, _script2, _defs, _circle, _path, _script3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEureLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    id: "argent-x-extension",
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb"
  })), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 137.46,
    y1: 50.68,
    x2: 374.54,
    y2: 461.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0095d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072aa"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:#fff}\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 255
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    cx: 256,
    cy: 256,
    r: 237.05,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m378.38 336.35-33-19a3.06 3.06 0 0 0-1.5-.4 3.22 3.22 0 0 0-.81.11 3 3 0 0 0-1.82 1.45 65.77 65.77 0 0 1-10.48 14.24 81.53 81.53 0 0 1-18.89 14.53 82.56 82.56 0 0 1-21.46 8.24 96.1 96.1 0 0 1-21.52 2.58 78.81 78.81 0 0 1-36.74-8.71 92.11 92.11 0 0 1-28.45-22.85 99.71 99.71 0 0 1-10.2-14.85l-3.88-6.89h83.78a3 3 0 0 0 3-3v-26.1a3 3 0 0 0-3-3h-93.1l-.46-4.12a122 122 0 0 1-.75-13.39c0-3.75.2-7.68.6-11.7l.42-4.17h93.29a3 3 0 0 0 3-3v-26.1a3 3 0 0 0-3-3h-84.67l3.59-6.79a99.67 99.67 0 0 1 8.76-13.76 86.35 86.35 0 0 1 27.68-23.58c11.14-6.08 24.35-9.17 39.27-9.17a98.94 98.94 0 0 1 21.06 2.36 84.71 84.71 0 0 1 20.8 7.58 74.91 74.91 0 0 1 29.56 28.46 3 3 0 0 0 1.94 1.41 2.79 2.79 0 0 0 .64.07 3 3 0 0 0 1.71-.53l30.65-21.11a3 3 0 0 0 .88-4c-9.08-15.27-22.06-28.06-38.58-38-18.7-11.25-41.25-17-67-17-21.85 0-41.57 4.12-58.62 12.24a136.52 136.52 0 0 0-70.74 77.08c-.1.25-.18.5-.26.75v.07q-.12.39-.27.78l-1.1 3.08H74.27a3 3 0 0 0-3 3v26.1a3 3 0 0 0 3 3h57.38l-.33 4.93c-.23 3.55-.34 6.51-.34 9.3 0 4.65.24 9.38.7 14.06l.5 5.09H74.27a3 3 0 0 0-3 3v26.1a3 3 0 0 0 3 3h66.16l1.17 2.92a154.3 154.3 0 0 0 27.74 45.35 144.14 144.14 0 0 0 43.06 33.13c16.45 8.36 34.9 12.6 54.82 12.6a147.65 147.65 0 0 0 34.94-4.37 144.12 144.12 0 0 0 33.53-12.7 123.48 123.48 0 0 0 28-20.32 83.64 83.64 0 0 0 15.83-21 3 3 0 0 0-1.14-4Z"
  })), _script3 || (_script3 = /*#__PURE__*/React.createElement("script", {
    id: "bw-fido2-page-script"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEureLogo);
export default __webpack_public_path__ + "static/media/eure-logo.7aa6971ad91792457488e91769eb55d7.svg";
export { ForwardRef as ReactComponent };